<template>
  <div class="clinic-fee-page">
    <el-row :gutter="18" class="fee-stat-row">
      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="fee-stat-card fee-stat-card--today" shadow="hover">
          <div class="fee-stat-inner">
            <div class="fee-stat-value numClass fee-stat-value--accent">{{ fees_today }}</div>
            <div class="fee-stat-label hintClass">今日收入</div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="fee-stat-card" shadow="hover">
          <div class="fee-stat-inner">
            <div class="fee-stat-value numClass">{{ fees_yesterday }}</div>
            <div class="fee-stat-label hintClass">昨日收入</div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="fee-stat-card" shadow="hover">
          <div class="fee-stat-inner">
            <div class="fee-stat-value numClass">{{ fees_this_week_vs_last_week }}</div>
            <div class="fee-stat-label hintClass">上周收入</div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="fee-stat-card" shadow="hover">
          <div class="fee-stat-inner">
            <div class="fee-stat-value numClass">{{ fees_this_week_vs_last_month }}</div>
            <div class="fee-stat-label hintClass">上月收入</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="fee-chart-wrap">
      <LineChart
        path="clinic_fees_trend"
        height="400px"
        chart_type="line"
        :params='{"clinic_id":clinic_id}'
      />
    </div>

    <div v-if="this.prop_clinic_id!='-1'" class="fee-table-panel">
      <el-row :gutter="16" class="fee-table-row">
        <el-col :span="24">
          <el-table
            :data="clinic_fee_by_doctor"
            :header-cell-style="{background:'#363944',color:'white',border:'none'}"
            :row-class-name="tableRowClassName"
            class="fee-detail-table"
          >
            <el-table-column prop="index" label="序号"></el-table-column>
            <el-table-column prop="doctor_name" label="医生姓名"></el-table-column>
            <el-table-column prop="total_fee" label="金额"></el-table-column>
            <el-table-column prop="月份" label="日期"></el-table-column>
          </el-table>

          <div class="block fee-page-footer">
            <el-select
              v-model="page_size"
              size="small"
              class="fee-page-size-select"
              @change="onPageSizeChange"
            >
              <el-option
                v-for="n in pageSizeOptions"
                :key="n"
                :label="`${n}条/页`"
                :value="n"
              />
            </el-select>
            <el-button size="small" class="fee-btn-prev" :disabled="page <= 1" @click="goPrevPage">上一页</el-button>
            <el-button size="small" class="fee-btn-next" :disabled="page >= totalPages" @click="goNextPage">下一页</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import LineChart from "@/views/charts/line";
import '@/assets/css/main.css';

export default {
  name: "ClinicBusinessFee",
  components: {
    LineChart,
  },
  props: {
    prop_clinic_id: {
      type: String,
      default: null,
    },
    prop_doctor_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : (localStorage.getItem('clinic_id') ? localStorage.getItem('clinic_id') : '1650588070122270721'),
      doctor_id: this.$route.query.doctor_id ? this.$route.query.doctor_id : (this.prop_doctor_id ? this.prop_doctor_id : '-1'),
      clinic_pre_by_doctor: [],
      clinic_fee_by_doctor: [],
      fees_today: "0",
      fees_yesterday: "0",
      fees_this_week_vs_last_week: "0",
      fees_this_week_vs_last_month: "0",

      kf_today: "0",
      kf_yesterday: "0",
      kf_this_week_vs_last_week: "0",
      kf_this_week_vs_last_month: "0",

      page:1,
      page_size:20,
      total_record: 0,
      /** 每页条数选项（下拉展示为 n条/页） */
      pageSizeOptions: [20, 50, 100, 200],
    }
  },
  computed: {
    /**
     * 根据总条数与每页条数计算总页数（至少 1 页，避免除零）
     */
    totalPages() {
      const size = Number(this.page_size) || 20;
      const total = Number(this.total_record) || 0;
      return Math.max(1, Math.ceil(total / size));
    },
  },
  mounted() {
    this.get_clinic_pre_by_doctor();
    this.get_clinic_fee_by_doctor();
    this.get_clinic_stat();
  },
  methods: {
    /**
     * 每页条数变更：回到第 1 页并重新请求费用明细
     */
    onPageSizeChange() {
      this.page = 1;
      this.get_clinic_fee_by_doctor();
    },
    /**
     * 上一页：页码减 1 后重新请求列表（已在第 1 页则无操作）
     */
    goPrevPage() {
      const p = Number(this.page) || 1;
      if (p <= 1) {
        return;
      }
      this.page = p - 1;
      this.get_clinic_fee_by_doctor();
    },
    /**
     * 下一页：页码加 1 后重新请求列表（已在最后一页则无操作）
     */
    goNextPage() {
      const p = Number(this.page) || 1;
      if (p >= this.totalPages) {
        return;
      }
      this.page = p + 1;
      this.get_clinic_fee_by_doctor();
    },

    get_clinic_stat() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_stat?clinic_id=" + this.clinic_id
          + "&doctor_id=" + this.doctor_id).then((res) => {

        this.fees_yesterday = res.data.data.fees_yesterday

        this.fees_today = res.data.data.fees_today
        let fees_compare_result = (100.0 * (this.fees_today - this.fees_yesterday) / this.fees_yesterday).toFixed(2)
        if (this.fees_yesterday == 0) {
          fees_compare_result = 0
        }
        this.fees_today = res.data.data.fees_today + "(较昨" + (fees_compare_result > 0 ? "增加" + fees_compare_result : "减少" + Math.abs(fees_compare_result)) + "%)"

        this.fees_this_week_vs_last_week = res.data.data.fees_this_week_vs_last_week
        this.fees_this_week_vs_last_month = res.data.data.fees_this_week_vs_last_month

        this.kf_today = res.data.data.kf_today

        this.kf_yesterday = res.data.data.kf_yesterday
        let kf_compare_result = (100.0 * (this.kf_today - this.kf_yesterday) / this.kf_yesterday).toFixed(2)
        if (this.kf_yesterday == 0) {
          kf_compare_result = 0
        }
        this.kf_today = res.data.data.kf_today + "(较昨日" + (kf_compare_result > 0 ? "增加" + kf_compare_result : "减少" + Math.abs(kf_compare_result)) + "%)"

        this.kf_this_week_vs_last_week = res.data.data.kf_this_week_vs_last_week
        this.kf_this_week_vs_last_month = res.data.data.kf_this_week_vs_last_month

        this.clinic_name = res.data.data.clinic_name
        /** 列表分页依赖稳定的 clinic_id；路由/本地已指定时不要被统计接口覆盖，否则翻页会查到别的诊所出现空表 */
        if (!this.$route.query.clinic_id && !localStorage.getItem('clinic_id')) {
          this.clinic_id = res.data.data.clinic_id
        }
      })
    },

    get_clinic_pre_by_doctor() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/clinic_pre_detail?clinic_id=" + this.clinic_id
          + "&doctor_id=" + this.doctor_id).then((res) => {
        this.clinic_pre_by_doctor = res.data.data
      })
    },
    /**
     * 拉取诊所按医生费用明细分页列表
     * 对 page / page_size 做数值化，避免字符串参与运算导致后端 OFFSET 异常；data 统一为数组
     */
    get_clinic_fee_by_doctor() {
      const pageNum = Math.max(1, parseInt(String(this.page), 10) || 1);
      const pageSize = Math.max(1, parseInt(String(this.page_size), 10) || 20);
      this.page = pageNum;
      this.page_size = pageSize;
      const url = process.env.VUE_APP_API_HOST + "/clinic_fees_detail?clinic_id=" + this.clinic_id
        + "&doctor_id=" + this.doctor_id + "&page=" + pageNum + "&page_size=" + pageSize;
      this.$http.get(url).then((res) => {
        const raw = res.data && res.data.data;
        this.clinic_fee_by_doctor = Array.isArray(raw) ? raw : [];
        const tr = res.data && res.data.total_record;
        this.total_record = tr !== undefined && tr !== null ? Number(tr) : 0;
      }).catch((e) => {
        console.error(e);
        this.$message.error("加载费用明细失败，请稍后重试");
      });
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}
</script>

<style scoped>
/**
 * 诊所收入：KPI 卡片、趋势图、明细分页表格的布局与深色主题统一（不改动 script 请求与分页逻辑）
 */

.clinic-fee-page {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 0 8px;
  margin: 0;
}

/* 顶部四项收入指标 */
.fee-stat-row {
  margin: 0 !important;
}

.fee-stat-row :deep(.el-col) {
  margin-bottom: 14px;
}

.fee-stat-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(165deg, #464a54 0%, #363944 100%);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.14);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
}

.fee-stat-card:hover {
  border-color: rgba(104, 245, 185, 0.22);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
}

.fee-stat-card--today {
  border-color: rgba(255, 138, 128, 0.35);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(255, 120, 100, 0.12);
}

.fee-stat-card :deep(.el-card__body) {
  padding: 16px 14px 18px;
  background: transparent;
}

.fee-stat-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 72px;
}

.fee-stat-value.numClass {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
  color: #f2f4f8;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fee-stat-value--accent {
  color: #ff9a8e !important;
}

.fee-stat-label.hintClass {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.8;
  margin: 0;
}

/* 趋势图区域 */
.fee-chart-wrap {
  margin-top: 8px;
  margin-bottom: 10px;
  padding: 14px 16px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  min-height: 400px;
}

/* 费用明细表格块 */
.fee-table-panel {
  margin-top: 6px;
  width: 100%;
  box-sizing: border-box;
}

.fee-table-row {
  margin: 0 !important;
  width: 100%;
}

.fee-detail-table {
  width: 100%;
}

.chart-container {
  position: relative;
  width: 100%;
  height: 200px;
}

.fee-detail-table :deep(tbody tr:hover) {
  color: black !important;
}

.fee-detail-table :deep(.warning-row1) {
  background: #363944;
}

.fee-detail-table :deep(.warning-row1 > td) {
  border: none;
}

.fee-detail-table :deep(.success-row1) {
  background: #3c3f4a;
}

.fee-detail-table :deep(.success-row1 > td) {
  border: none;
}

.fee-page-footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 0;
  padding: 14px 4px 6px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.fee-page-size-select {
  width: 110px;
}

.fee-page-footer :deep(.fee-page-size-select .el-input__inner) {
  background: #ffffff !important;
  color: #303133 !important;
  border-radius: 6px !important;
  border: none !important;
  box-shadow: none !important;
  height: 32px !important;
  line-height: 32px !important;
  font-size: 13px;
}

.fee-page-footer :deep(.fee-page-size-select .el-input__suffix) {
  color: #909399;
}

.fee-page-footer :deep(.fee-btn-prev) {
  background: #ffffff !important;
  color: #606266 !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 9px 20px;
  font-size: 13px;
}

.fee-page-footer :deep(.fee-btn-prev:hover),
.fee-page-footer :deep(.fee-btn-prev:focus) {
  background: #f0f0f0 !important;
  color: #303133 !important;
}

.fee-page-footer :deep(.fee-btn-next) {
  background: #1ec969 !important;
  border-color: #1ec969 !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 9px 20px;
  font-size: 13px;
}

.fee-page-footer :deep(.fee-btn-next:hover),
.fee-page-footer :deep(.fee-btn-next:focus) {
  background: #18b35a !important;
  border-color: #18b35a !important;
  color: #ffffff !important;
}

.fee-page-footer :deep(.fee-btn-next.is-disabled),
.fee-page-footer :deep(.fee-btn-prev.is-disabled) {
  opacity: 0.45;
}
</style>
